(function () {
  'use strict';

  if (window.AyamiOnboardingProgress) return;

  var BRIDGE_SEEN_PREFIX = 'ayami_onboarding_bridge_seen_';
  var SAMPLE_BRIDGE_KEYS = ['fabric', 'color-samples'];

  var LOCAL_DONE_CHECKS = {
    comfort: function () {
      try {
        for (var i = 0; i < localStorage.length; i += 1) {
          var key = localStorage.key(i);
          if (key && key.indexOf('ayami_comfort_profile_') === 0) {
            var raw = localStorage.getItem(key);
            if (raw && raw.length > 8) return true;
          }
        }
      } catch (e) {}
      return false;
    },
    guide: function () {
      try {
        for (var i = 0; i < localStorage.length; i += 1) {
          var key = localStorage.key(i);
          if (key && key.indexOf('color_guide_saved_') === 0) {
            var raw = localStorage.getItem(key);
            if (raw && raw.length > 8) return true;
          }
        }
      } catch (e) {}
      return false;
    },
    vote: function () {
      try {
        var raw = localStorage.getItem('ayami_color_vote_abuja');
        if (!raw) return false;
        var data = JSON.parse(raw);
        return !!(data && (data.votes || data.selected || data.colors));
      } catch (e) {
        return false;
      }
    },
    'fabric-prefs': function () {
      try {
        var raw = localStorage.getItem('ayami_fabric_preferences');
        if (!raw) return false;
        var data = JSON.parse(raw);
        if (!data || !Array.isArray(data.fabrics) || !data.fabrics.length) return false;
        return data.fabrics.some(function (item) {
          var vote = String((item && item.vote) || '').toLowerCase();
          return (
            vote === 'love' ||
            vote === 'acceptable' ||
            vote === 'not_for_me' ||
            vote === 'like' ||
            vote === 'dislike'
          );
        });
      } catch (e) {
        return false;
      }
    },
    size: function () {
      try {
        var raw = localStorage.getItem('ayami_size_profile');
        if (!raw) return false;
        var data = JSON.parse(raw);
        return !!(data && (data.recommended_eu || data.bust_cm));
      } catch (e) {
        return false;
      }
    },
  };

  function parseData() {
    var el = document.getElementById('AyamiOnboardingProgressData');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function cloneSteps(data) {
    if (!data || !Array.isArray(data.steps)) return [];
    return data.steps.map(function (step) {
      var done = !!step.done;
      var checker = LOCAL_DONE_CHECKS[step.key];
      if (!done && checker) {
        try {
          done = !!checker();
        } catch (e) {
          done = !!step.done;
        }
      }
      return {
        key: step.key,
        index: step.index,
        label: step.label,
        cta: step.cta,
        body: step.body,
        url: step.url,
        done: done,
      };
    });
  }

  var data = parseData();
  var steps = cloneSteps(data);
  var accountUrl = (data && data.accountUrl) || '/account';
  var onboardingUrl = (data && data.onboardingUrl) || '/pages/onboarding';

  function stepIndex(key) {
    for (var i = 0; i < steps.length; i += 1) {
      if (steps[i].key === key) return i;
    }
    return -1;
  }

  function getSteps() {
    return steps.slice();
  }

  function isDone(key) {
    var idx = stepIndex(key);
    return idx >= 0 ? !!steps[idx].done : false;
  }

  function markDone(key) {
    var idx = stepIndex(key);
    if (idx >= 0) steps[idx].done = true;
  }

  function firstIncomplete(afterKey) {
    var start = 0;
    if (afterKey) {
      var idx = stepIndex(afterKey);
      if (idx >= 0) start = idx + 1;
    }
    for (var i = start; i < steps.length; i += 1) {
      if (!steps[i].done) return steps[i];
    }
    return null;
  }

  function nextIncomplete(afterKey) {
    return firstIncomplete(afterKey);
  }

  function allDone() {
    for (var i = 0; i < steps.length; i += 1) {
      if (!steps[i].done) return false;
    }
    return steps.length > 0;
  }

  function accountStep() {
    return {
      key: 'account',
      index: 99,
      label: 'Your profile',
      cta: 'Go to your profile',
      body: 'All onboarding steps are done. Open your personal area anytime to review or update.',
      url: accountUrl,
      done: false,
    };
  }

  function bridgeSeenKey(stepKey) {
    return BRIDGE_SEEN_PREFIX + stepKey;
  }

  function hasSeenBridge(stepKey) {
    try {
      return localStorage.getItem(bridgeSeenKey(stepKey)) === '1';
    } catch (e) {
      return false;
    }
  }

  function markBridgeSeen(stepKey) {
    try {
      localStorage.setItem(bridgeSeenKey(stepKey), '1');
    } catch (e) {}
  }

  function isOnboardingPage() {
    try {
      var path = window.location.pathname.replace(/\/+$/, '');
      var target = String(onboardingUrl).split('?')[0].replace(/\/+$/, '');
      return path === target || /\/pages\/onboarding$/i.test(path);
    } catch (e) {
      return false;
    }
  }

  function pendingSampleBridgeKey() {
    for (var i = 0; i < SAMPLE_BRIDGE_KEYS.length; i += 1) {
      var key = SAMPLE_BRIDGE_KEYS[i];
      if (isDone(key) && !hasSeenBridge(key)) return key;
    }
    return null;
  }

  function maybeRedirectToPendingBridge() {
    if (isOnboardingPage()) return false;
    if (!(data && data.loggedIn)) return false;
    var key = pendingSampleBridgeKey();
    if (!key) return false;
    var url =
      onboardingUrl +
      (String(onboardingUrl).indexOf('?') >= 0 ? '&' : '?') +
      'from=' +
      encodeURIComponent(key);
    window.location.replace(url);
    return true;
  }

  window.AyamiOnboardingProgress = {
    getSteps: getSteps,
    isDone: isDone,
    markDone: markDone,
    firstIncomplete: firstIncomplete,
    nextIncomplete: nextIncomplete,
    allDone: allDone,
    accountStep: accountStep,
    accountUrl: accountUrl,
    onboardingUrl: onboardingUrl,
    markBridgeSeen: markBridgeSeen,
    hasSeenBridge: hasSeenBridge,
    maybeRedirectToPendingBridge: maybeRedirectToPendingBridge,
    pendingSampleBridgeKey: pendingSampleBridgeKey,
  };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    maybeRedirectToPendingBridge();
  });
})();
